module.exports = __webpack_public_path__ + "37fefefcfd1a1e4dd4b05c2125ed78cf.woff";